import { Button, Spinner } from '@crm/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { FormError, FormField } from '@/components';
import { AUTH_ROUTES } from '../constants';
import { useRegister } from '../hooks';
import { type RegisterFormValues, registerSchema } from '../schemas';
import { toErrorMessage } from '../utils';

export function RegisterForm() {
  const registerMutation = useRegister();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<RegisterFormValues>({
    resolver: zodResolver(registerSchema),
    defaultValues: { name: '', email: '', password: '', confirmPassword: '' },
  });

  return (
    <form
      className="space-y-4"
      onSubmit={handleSubmit((values) => registerMutation.mutate(values))}
      noValidate
    >
      <FormError message={registerMutation.error ? toErrorMessage(registerMutation.error) : null} />

      <FormField
        label="Nome"
        autoComplete="name"
        placeholder="Seu nome completo"
        error={errors.name?.message}
        {...register('name')}
      />

      <FormField
        label="E-mail"
        type="email"
        autoComplete="email"
        placeholder="voce@empresa.com"
        error={errors.email?.message}
        {...register('email')}
      />

      <FormField
        label="Senha"
        type="password"
        autoComplete="new-password"
        placeholder="Minimo 8 caracteres"
        error={errors.password?.message}
        {...register('password')}
      />

      <FormField
        label="Confirmar senha"
        type="password"
        autoComplete="new-password"
        placeholder="Repita a senha"
        error={errors.confirmPassword?.message}
        {...register('confirmPassword')}
      />

      <Button type="submit" className="w-full" disabled={registerMutation.isPending}>
        {registerMutation.isPending ? <Spinner /> : null}
        Criar conta
      </Button>

      <p className="text-center text-sm text-muted-foreground">
        Ja tem conta?{' '}
        <Link to={AUTH_ROUTES.LOGIN} className="font-medium text-primary hover:underline">
          Entrar
        </Link>
      </p>
    </form>
  );
}
